import { TableProps } from 'antd';
import classNames from 'classnames';

import { ReactComponent as RightArrow } from 'shared/assets/icons/dynamicColor/arrow-right.svg';

import { CountryList, GroupedCountryList } from '../../CountryTable.types';
import styles from './ExpandIcon.module.scss';

const isGroup = (record: CountryList): record is GroupedCountryList => {
  return 'children' in record && Array.isArray(record.children) && 'title' in record;
};

export const ExpandIcon: Required<TableProps<CountryList>>['expandable']['expandIcon'] = ({ record, expanded }) => {
  if (!isGroup(record)) {
    return null;
  }
  return (
    <span className={styles.expandIcon}>
      <RightArrow className={classNames([styles.icon, { [styles.expanded]: expanded }])} />
      <span>{record?.title}</span>
    </span>
  );
};
